import { useMemo } from 'react'
import type { StoreState } from 'client/store'
import { useSelector } from 'react-redux'
import { Role } from 'client/enums/Role'

type RolesInfo = {
  isAnonymous: boolean
  isIdentified: boolean
  isSubscriber: boolean
  isQRHost: boolean
}

const useRoles = (): RolesInfo => {
  const roles = useSelector<StoreState, Role[]>((state) => state.user?.roles)

  return useMemo<RolesInfo>(() => (
    {
      isAnonymous: roles.includes(Role.anonymous),
      isIdentified: roles.includes(Role.identified),
      isSubscriber: roles.includes(Role.subscriber),
      isQRHost: roles.includes(Role.qrHost),
    }
  ), [roles])
}

export default useRoles
